<mat-form-field class="text-form-field" appearance="outline">
    <mat-label>{{normalizedLabel}}</mat-label>
    <input matInput type="text" name="{{label}}-{{key}}"
        [required]="required" [disabled]="disabled" [readonly]="readonly"
        attr.data-testid="record-{{label}}-text"
        [(ngModel)]="value" (ngModelChange)="onFieldChange.emit($event)">
</mat-form-field>